import { render, staticRenderFns } from "./SubmitSourceFilesPageContainer.vue?vue&type=template&id=6356ea44&"
import script from "./SubmitSourceFilesPageContainer.vue?vue&type=script&lang=js&"
export * from "./SubmitSourceFilesPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports